import { Immutable } from "immer";
import React from "react";
import {
    Gallery,
    type IGalleryImage,
} from "tsi-common-react/src/components/Gallery/index";

import type { PDPCarouselBlock as PDPCarouselBlockValue } from "@reactivated";

type IProps = Immutable<{ value: PDPCarouselBlockValue }>;
type CarouselPane = NonNullable<IProps["value"]["carousel"]>[number];
type CarouselImage = NonNullable<CarouselPane["image"]>;

const getImageAlt = (image: CarouselImage): string => {
    return image.default_alt_text || image.title;
};

const getThumbnailURL = (image: CarouselImage): string => {
    return image.renditions["width-200"]?.url ?? image.url;
};

export const CocoonPDPCarouselBlock = (
    props: IProps,
): React.JSX.Element | null => {
    const carousel = props.value.carousel ?? [];
    const images: IGalleryImage[] = carousel.flatMap((pane) => {
        if (!pane.image) {
            return [];
        }
        const image = pane.image;
        return [
            {
                originalURL: image.url,
                originalAlt: getImageAlt(image),
                thumbnailURL: getThumbnailURL(image),
                thumbnailAlt: getImageAlt(image),
                caption: pane.caption ?? "",
            },
        ];
    });

    if (images.length === 0) {
        return null;
    }

    return <Gallery images={images} alternateArrows={true} />;
};
